import { Box, Tooltip } from "@mui/joy";
import { Trash2 } from "lucide-react";
import { IconButton } from "../../../../shared";

export function ActionsRenderer(props: any) {
    const { data, context } = props;

    const handleDelete = () => {
        if (context && context.onDelete) {
            context.onDelete(data.Id);
        }
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Tooltip title="Delete template" placement="top">
                <IconButton
                    size="sm"
                    variant="soft"
                    color="danger"
                    onClick={handleDelete}
                    sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        "--IconButton-size": "32px",
                        borderRadius: "4px",
                    }}
                >
                    <Trash2 size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
